module.exports = __webpack_public_path__ + "img/gb9877_1-88-70x100x10.prt.c2390d23.jpg";